import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getOpportunityNoteListData } from './mockData'
import type { IOpportunityNote } from '~/types/note/models'

export const {
  getNotes: getOpportunityNotes,
  postNote: postOpportunityNote,
  patchNote: patchOpportunityNote,
  deleteNote: deleteOpportunityNote,
  handlers,
} = makeNoteAPIs<IOpportunityNote>({
  apiPathEntityNamePrefix: 'opportunity',
  getNoteListDataFn: getOpportunityNoteListData,
})
